import api from './api';

const save = data => {
  return api.post('/api/ticket/save', data);
};

const uploadAttachments = (files, ticketId, onUploadProgress) => {
  const formData = new FormData();
  formData.append('ticketId', ticketId);

  files.forEach((file, index) => {
    const name =
      file.fileName ||
      file.name ||
      `attachment-${Date.now().toString()}-${index}`;

    formData.append('files', file, name);
  });

  return api.post('/api/ticket/attach', formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

const getAll = (status, createdById, company) => {
  return api.get('/api/ticket/get_all', {
    params: {
      status,
      createdById,
      company,
    },
  });
};

const getOne = ticketId => {
  return api.get('/api/ticket/get_one', {
    params: {
      ticketId,
    },
  });
};

const update = data => {
  return api.post('/api/ticket/update', data);
};

const hasUnread = () => {
  return api.get('/api/ticket/has_unread');
};

const getUnreadIds = () => {
  return api.get('/api/ticket/unread_ids');
};

const markRead = ticketId => {
  return api.post('/api/ticket/mark_read', { ticketId });
};

const TicketService = {
  save,
  uploadAttachments,
  getAll,
  getOne,
  update,
  hasUnread,
  getUnreadIds,
  markRead,
};

export default TicketService;
